import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import MDEditor from '@uiw/react-md-editor';
import LogoNoText from '../../../svg/LogoNoText.js';
import InquirySvg from '../../../svg/student/Inquiry.js';
import LeftArrowSvg from '../../../svg/student/Left.js';
import RightArrowSvg from '../../../svg/student/Right.js';
import PreviousSvg from '../../../svg/student/Previous.js';
import NextSvg from '../../../svg/student/Next.js';
import ReloadSvg from '../../../svg/student/Reload.js';
import Instructions from '../../student/Instructions.js';
import { getDragAndDropScore, getMCQScore, getQuestionScore, getStudentScore, getTableScore, getTimeToComplete, getTotalScore } from '../../../util/mission.js';
import PopupWindow from './TextPopupWindow';
import { adminUpdateStudentMissions, teacherUpdateRemarks } from '../../../services/studentMissions.service.js';
import LoadingPage from '../../components/LoadingPage';

const dragAndDropWidth = 180
const dragAndDropHeight = 180

function Component(props) {
    const mission= props.mission

    const [isloading, setisLoading] = useState(false)


    const [questionIndex, setquestionIndex] = useState(0);
    const selectQuestion = (item, index) => () => {
        setquestionIndex(index)
    }
    const progress = mission?.progress || 0



    const [tabIndex, settabIndex] = useState(0);

    const [dragSource, setdragSource] = useState(null)

    const handlePreviousQuestion = async () => {
        if (questionIndex === 0) return
        setquestionIndex(questionIndex - 1)
    }

    const handleNextQuestion = async () => {

        if (questionIndex === mission?.questions?.length - 1) {
            return
        }
        setquestionIndex(questionIndex + 1)
    }

    const isDraggable = (optionIndex) => {
        for (let column of mission?.questions[questionIndex]?.dragAndDrop) {
            for (let row of column?.rows) {
                if (row.studentAnswer === mission?.questions[questionIndex]?.dragAndDropOptions?.[optionIndex]?.text) {
                    return false
                }
            }
        }
        return true
    }
    {/*handle popup window*/ }
    const [isShowPopup, setisShowPopup] = useState(false)

    const [isShowInstruction, setisShowInstruction] = useState(false)
    const [isShowRemarksPopup, setisShowRemarksPopup] = useState(null)

    const handleUpdateRemarks=async()=>{
        setisLoading(true)
        let result = await teacherUpdateRemarks(props.token.token, mission._id,  isShowRemarksPopup )
        if (result.errno) {
            alert(result.message||'Error')
        }else {
            if(props.refresh){
                props.refresh()
                setisShowRemarksPopup(null)
            }
            alert('儲存成功')
        }
        setisLoading(false)
    }
    const handleUpdateScore=(q,qi,score,is888=false,is999=false)=>async ()=>{
        setisLoading(true)
        let questions = [...mission.questions]
        questions[qi] = { ...q, markingScore: score, markingTime: new Date(), is888,is999 }
        let result = await adminUpdateStudentMissions(props.token.token, mission._id, {
            questions,
        })
        if(result.errno) {
            alert(JSON.stringify(result.message)||'Error')
        }else {
            if(props.refresh){
                props.refresh()
            }
        }
        setisLoading(false)
    }

    return (
        <div className='relative h-full min-h-[800px] min-w-[1024px] flex-1 bg-[#F2F2F2] flex-col flex text-[16px] text-[black]' style={{ overflowY: "auto" }}>

            <div className='w-full flex flex-row items-center justify-start items-center gap-[8px] flex-wrap p-[16px] font-[700]'>
                <div className='flex-1 min-w-[300px]'>閲讀任務名稱: {mission?.name}</div>
                <div className='flex-1 min-w-[300px]'>學校名稱: {mission?.school?.name}</div>
                <div className='flex-1 min-w-[300px]'>學生姓名: {mission?.student?.name}</div>
                <div className='flex-1 min-w-[300px]'>學生班級: {mission?.student?.class}</div>
                <div className='flex-1 min-w-[300px]'>學生性別: {mission?.student?.gender}</div>
                <div className='flex-1 min-w-[300px]'>開始時間: {mission?.startTime ? new Date(mission.startTime).toLocaleString() : ''}</div>
                <div className='flex-1 min-w-[300px]'>完成時間: {mission?.finishTime ? new Date(mission.finishTime).toLocaleString() : ''}</div>
                <div className='flex-1 min-w-[300px]'>回答時間（分:秒）: {getTimeToComplete(mission)}</div>
                <div className='flex-1 min-w-[300px]'>任務狀態: {mission?.status}</div>
                <div className='flex-1 min-w-[300px]'>分數: {getStudentScore(mission?.questions)}/{getTotalScore(mission?.questions)}</div>
                <div className='flex-[2] min-w-[300px] flex flex-row justify-between items-center'>
                    老師評語: {mission?.remarks||''}
                    {props.token?.usertype==='teacher'&&<button className='ml-[16px] text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }} onClick={() => { setisShowRemarksPopup(mission?.remarks||'') }} >
                        編輯評語
                    </button>}
                </div>
            </div>
            {/*header*/}
            <div className='h-[80px] w-full flex flex-row justify-between items-center gap-[16px] bg-[white] px-[24px] flex-wrap'>
                <div className='text-[32px] font-[700] text-[#1F4CC8]' style={{}}>
                    <LogoNoText width='90px' />
                </div>
                <div className='flex-1 flex flex-row justify-start items-center gap-[24px] ml-[32px]'>
                    <div className='bg-[#C3E9FF] flex flex-row p-[6px] gap-[6px]'>
                        {mission?.questions?.map((item, index) =>
                            <div onClick={selectQuestion(item, index)} key={item?.id || index} className='h-[48px] w-[36px] cursor-pointer flex flex-row justify-center items-center font-[700]' style={{ backgroundColor: index === questionIndex ? '#1F4CC8' : index <= progress ? '#00E9BA' : 'white', border: '2px solid #D9D9D9', color: getQuestionScore(item) === item?.score ? 'green' : 'red' }}>
                                {getQuestionScore(item)}/{item?.score || "0"}
                            </div>
                        )}
                    </div>
                </div>
                <div className='flex flex-row gap-[16px]'>
                    <div onClick={() => { setisShowInstruction(true) }} className='h-[48px] w-[48px] rounded-[7px] bg-[#00E9BA] flex justify-center items-center cursor-pointer hover:opacity-[0.8]'>
                        <InquirySvg width={36} height={36} />
                    </div>
                    <div onClick={handlePreviousQuestion} className='ml-[36px] h-[48px] w-[48px] rounded-[7px] bg-[#1F4CC8] flex justify-center items-center cursor-pointer hover:opacity-[0.8]'>
                        <LeftArrowSvg width={36} height={36} />
                    </div>
                    <div onClick={handleNextQuestion} className='h-[48px] w-[48px] rounded-[7px] bg-[#1F4CC8] flex justify-center items-center cursor-pointer hover:opacity-[0.8]'>
                        <RightArrowSvg width={36} height={36} />
                    </div>
                </div>
            </div>
            {/*end of header*/}

            {/*content*/}
            <div className='flex flex-row w-full flex-1 bg-[#D9D9D9]  p-[10px] gap-[10px]' style={{ overflow: 'hidden' }}>
                {/*question*/}
                <div className='flex flex-col h-full w-[600px] bg-[white] justify-start items-start gap-[16px] text-[16px] text-[black] p-[16px]' style={{ border: '10px solid #E3F5FF' }}>
                    <div className='w-full bg-[#1F4CC8] p-[16px] text-[white] text-[16px]'>
                        <div className='text-[24px] font-[700]'>{mission?.name}</div>
                        <div>問題 {questionIndex + 1} / {mission?.questions.length}</div>
                    </div>
                    <div className='italic'>
                        {mission?.questions?.[questionIndex]?.dialog}
                    </div>
                    <div className='flex-1 w-full' style={{ overflowY: 'auto' }}>
                        {['短句作答題'].includes(mission?.questions?.[questionIndex].type) || <MDEditor.Markdown source={mission?.questions?.[questionIndex]?.question || ''} style={{ whiteSpace: 'pre-wrap', color: "black", backgroundColor: "transparent" }} />}
                        {['選擇題', '選擇題 + 短句作答題'].includes(mission?.questions?.[questionIndex].type) &&
                            <div className='w-full mt-[16px] flex flex-col items-start gap-[16px]'>
                                {mission?.questions?.[questionIndex]?.options?.map((option, optionIndex) =>
                                    <div key={optionIndex} className='flex flex-row gap-[8px] items-center'>
                                        <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                            <button onClick={() => { }}
                                                className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${option.isSelected ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                            ></button>
                                        </div>
                                        {option.text}
                                    </div>
                                )}

                                <div className='font-[700]'>正確答案: {mission?.questions?.[questionIndex]?.options?.filter(i => i.correct)?.reduce((acc, i) => { return acc + i.text }, '')}</div>
                                {['選擇題'].includes(mission?.questions?.[questionIndex].type)&&
                                    <div className='font-[700]'>分數: {getMCQScore(mission?.questions?.[questionIndex])}/{mission?.questions?.[questionIndex]?.score || "0"}</div>
                                }
                            </div>
                        }
                        {['短句作答題', '選擇題 + 短句作答題'].includes(mission?.questions[questionIndex]?.type) && (
                            <div className='w-fill mt-[16px] flex flex-col p-[2px]'>
                                <MDEditor.Markdown source={mission?.questions?.[questionIndex]?.questionShortanswer || ''} style={{ whiteSpace: 'pre-wrap', color: "black", backgroundColor: "transparent" }} />
                                <textarea disabled={true}
                                    className='w-full flex flex-col p-[16px] bg-[#F8F8F8] gap-[8px] rounded-[2px] mt-[16px]' style={{ border: '1px solid #00000080', boxShadow: '0px 0px 2px 2px rgb(217,229,193)' }}
                                    value={mission?.questions?.[questionIndex]?.answer || ''}
                                />
                   
                                {props.token?.usertype==='admin'&& mission?.questions?.[questionIndex]?.score>=1 &&<div className='font-[700] mt-[8px] flex flex-row items-center flex-wrap justify-start gap-[8px]'>
                                    批改分數: 
                                    {Array.from(Array(mission?.questions?.[questionIndex]?.score+1).keys())?.map((i) =>
                                        <div onClick={handleUpdateScore(mission?.questions?.[questionIndex],questionIndex,i)} key={i} className='px-[12px] py-[4px] cursor-pointer rounded-[8px]' style={{
                                            opacity:(mission?.questions?.[questionIndex].markingScore===i&&(!mission?.questions?.[questionIndex].is888)&&(!mission?.questions?.[questionIndex].is999))?1:.5,
                                            backgroundColor:(mission?.questions?.[questionIndex].markingScore===i&&(!mission?.questions?.[questionIndex].is888)&&(!mission?.questions?.[questionIndex].is999))?'#1F4CC8':'#bbb',
                                            color:(mission?.questions?.[questionIndex].markingScore===i&&(!mission?.questions?.[questionIndex].is888)&&(!mission?.questions?.[questionIndex].is999))?'white':'black'
                                        }}>{i} 分 </div>
                                    )}
                                    <div onClick={handleUpdateScore(mission?.questions?.[questionIndex],questionIndex,0,true)} className='px-[12px] py-[4px] cursor-pointer rounded-[8px]' style={{
                                        opacity:mission?.questions?.[questionIndex].is888?1:.5,
                                        backgroundColor:mission?.questions?.[questionIndex].is888?'#1F4CC8':'#bbb',
                                        color:mission?.questions?.[questionIndex].is888?'white':'black'}
                                    }> 888 </div>
                                    <div onClick={handleUpdateScore(mission?.questions?.[questionIndex],questionIndex,0,false,true)} className='px-[12px] py-[4px] cursor-pointer rounded-[8px]' style={{
                                        opacity:mission?.questions?.[questionIndex].is999?1:.5,
                                        backgroundColor:mission?.questions?.[questionIndex].is999?'#1F4CC8':'#bbb',
                                        color:mission?.questions?.[questionIndex].is999?'white':'black'}}
                                    > 999 </div>
                                </div>}

                                <div className='font-[700] mt-[8px]'>分數: {getQuestionScore(mission?.questions?.[questionIndex])}/{mission?.questions?.[questionIndex]?.score || "0"}</div>
                               
                            </div>
                        )}
                        {/*end of open end question*/}


                        {['表格問題'].includes(mission?.questions[questionIndex]?.type) && (
                            <div className='w-full flex flex-col gap-[8px] rounded-[7px] mt-[24px]'>
                                <div className='flex flex-col w-full'>
                                    <div className='font-[700] mt-[16px]'>學生答案:</div>
                                    <div className='flex flex-row items-stretch w-full border-black font-[700]'>
                                        <div className='bg-[#777] text-white flex-1 border-[black] border-[1px] w-full px-[12px] py-[4px] flex items-center justify-center'>
                                            {mission.questions[questionIndex]?.header?.[0] || ''}
                                        </div>
                                        <div className='bg-[#777] text-white border-[black] border-[1px] px-[12px] py-[4px] w-[100px] text-center flex items-center justify-center'>
                                            {mission.questions[questionIndex]?.header?.[1] || ''}
                                        </div>
                                        <div className='bg-[#777] text-white border-[black] border-[1px] px-[12px] py-[4px] w-[100px] text-center flex items-center justify-center'>
                                            {mission.questions[questionIndex]?.header?.[2] || ''}
                                        </div>
                                    </div>
                                    {mission?.questions[questionIndex]?.table?.map((row, rowIndex) => (
                                        <div key={rowIndex} className='flex flex-row items-stretch'>
                                            <div className='flex-1 bg-[#F0F0F0] border-black border-x-[1px] border-y-[1px] px-[12px] py-[4px]'>{row.text}</div>
                                            <div className='w-[100px] border-[black] border-[1px] px-[12px] py-[4px] flex flex-row justify-center items-center bg-[#F0F0F0]'>
                                                <div>
                                                    <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                        <button disabled={true}
                                                            className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${row.answer1 ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                        ></button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='w-[100px] border-[black] border-[1px] px-[12px] py-[4px] flex flex-row justify-center justify-center items-center bg-[#F0F0F0]'>
                                                <div>
                                                    <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                        <button disabled={true}
                                                            className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${row.answer2 ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                        ></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <div className='font-[700] mt-[16px]'>正確答案:</div>
                                    <div className='flex flex-row items-stretch w-full border-black font-[700]'>
                                        <div className='bg-[#777] text-white flex-1 border-[black] border-[1px] w-full px-[12px] py-[4px] flex items-center justify-center'>
                                            {mission.questions[questionIndex]?.header?.[0] || ''}
                                        </div>
                                        <div className='bg-[#777] text-white border-[black] border-[1px] px-[12px] py-[4px] w-[100px] text-center flex items-center justify-center'>
                                            {mission.questions[questionIndex]?.header?.[1] || ''}
                                        </div>
                                        <div className='bg-[#777] text-white border-[black] border-[1px] px-[12px] py-[4px] w-[100px] text-center flex items-center justify-center'>
                                            {mission.questions[questionIndex]?.header?.[2] || ''}
                                        </div>
                                    </div>
                                    {mission?.questions[questionIndex]?.table?.map((row, rowIndex) => (
                                        <div key={rowIndex} className='flex flex-row items-stretch'>
                                            <div className='flex-1 bg-[#F0F0F0] border-black border-x-[1px] border-y-[1px] px-[12px] py-[4px]'>{row.text}</div>
                                            <div className='w-[100px] border-[black] border-[1px] px-[12px] py-[4px] flex flex-row justify-center items-center bg-[#F0F0F0]'>
                                                <div>
                                                    <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                        <button disabled={true}
                                                            className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${row.correct1 ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                        ></button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='w-[100px] border-[black] border-[1px] px-[12px] py-[4px] flex flex-row justify-center justify-center items-center bg-[#F0F0F0]'>
                                                <div>
                                                    <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                        <button disabled={true}
                                                            className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${row.correct2 ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                        ></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <div className='font-[700] mt-[16px]'>分數: {getTableScore(mission?.questions?.[questionIndex])}/{mission?.questions?.[questionIndex]?.score || "0"}</div>
                                </div>
                            </div>
                        )}
                        {/*end of form table question*/}


                        {/*drag and drop question*/}
                        {['拖放式問題'].includes(mission?.questions[questionIndex]?.type) && (
                            <div className='w-full flex flex-col p-[16px] bg-[#F8F8F8] gap-[8px] rounded-[7px]'>
                                <div className='w-full flex flex-row justify-start items-stretch'>
                                    {mission?.questions[questionIndex]?.dragAndDrop?.map((column, columnIndex) =>
                                        <div key={columnIndex} className='bg-[rgb(210,210,210)] p-[2px] min-w-[100px] form-input flex flex-col'>
                                            <div className='flex flex-col flex-[1] w-full gap-[4px]'>
                                                <div className='bg-[rgb(230,238,247)] text-black w-full font-[700] px-[12px] py-[4px]'>
                                                    {column?.title || ''}
                                                </div>

                                                {column?.rows?.map((row, rowIndex) =>
                                                    <div key={rowIndex} className='p-[2px] relative'>
                                                        {row?.type === '拖放格' && <div className='relative bg-white flex flex-col items-center justify-center p-[4px]'
                                                            style={{ width: dragAndDropWidth, height: dragAndDropHeight * (row.size || 1), border: row?.studentAnswer ? '1px solid black' : 'none' }}>
                                                            <b>學生答案:</b> {row?.studentAnswer || ''}
                                                            <br /><br />
                                                            <b>正確答案:</b>{row.answer || ''}
                                                        </div>}
                                                        {row?.type === '文字' && <div className='bg-white flex flex-col' style={{ width: dragAndDropWidth, height: dragAndDropHeight * (row.size || 1) }}>
                                                            <div className='px-[16px] py-[6px] rounded-[7px] w-full h-full flex items-center justify-center' >
                                                                {row?.text || ''}
                                                            </div>
                                                        </div>}
                                                        {row?.type === '空白區域' && <div className='flex flex-col' style={{ width: dragAndDropWidth, height: dragAndDropHeight * (row.size || 1) }}>
                                                        </div>}

                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className='flex flex-row w-full gap-[2%] flex-wrap'>
                                    {mission?.questions[questionIndex]?.dragAndDropOptions?.map((option, optionIndex) => (
                                        <div className='flex flex-row items-center cursor-pointer bg-[white] rounded-[2px] select-none w-[32%] mb-[8px]'
                                            draggable={false} key={optionIndex}
                                            style={{ aspectRatio: 1, opacity: isDraggable(optionIndex) ? 1 : .3, border: '1px solid black', boxShadow: dragSource === optionIndex ? '0px 0px 2px 2px green' : '0px 0px 1px 1px #00000080' }}>

                                            <div className=' px-[12px] py-[4px]]' style={{ display: 'inline-block' }}>
                                                {option.text}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className='font-[700]'>分數: {getDragAndDropScore(mission?.questions?.[questionIndex])}/{mission?.questions?.[questionIndex]?.score || "0"}</div>
                            </div>
                        )}

                    </div>
                </div>
                {/*end of question*/}

                {/*webpages*/}
                <div className='flex flex-col w-full bg-[#EEF2F6]' style={{ border: '10px solid #EEF2F6' }}>
                    {/*tabs*/}
                    <div className='flex flex-row w-full items-end justify-start px-[16px] gap-[8px] pt-[6px] bg-[white]' style={{ border: '2px solid #D9D9D9' }} >
                        {mission?.pages?.map((page, index) =>
                            page?.initial ?
                                <div onClick={() => { settabIndex(index) }} key={page.id || index} className='flex flex-row items-center gap-[8px] px-[12px] py-[4px] cursor-pointer hover:opacity-[.7] mb-[-2px]' style={{ backgroundColor: tabIndex === index ? '#EEF2F6' : 'white', borderTop: '2px solid #D9D9D9', borderLeft: '2px solid #D9D9D9', borderRight: '2px solid #D9D9D9', borderBottom: tabIndex === index ? '2px solid #EEF2F6' : '2px solid white' }}>
                                    {/* <div className='w-[20px] h-[20px] bg-[#eee] rounded-[7px]'>
                                            {page?.icon && <img src={page?.icon} alt='icon' className='w-full h-full object-cover' />}
                                        </div> */}
                                    <div className='text-[16px] font-[900]' style={{ color: tabIndex == index ? 'black' : 'black' }}>{page?.name}</div>
                                </div>
                                : <div key={page?.id || index} />
                        )}
                    </div>
                    <div className='w-full flex flex-row bg-[white] p-[6px] gap-[6px] items-center mt-[12px]' style={{ borderBottom: '3px solid #E3E3E3' }}>
                        <div className='cursor-pointer'>
                            <PreviousSvg height={30} width={30} />
                        </div>
                        <div className='cursor-pointer'>
                            <NextSvg height={30} width={30} />
                        </div>
                        <div className='cursor-pointer'>
                            <ReloadSvg height={30} width={30} />
                        </div>
                        <div className='flex-1'>
                            <input disabled={true} className='w-full text-[16px] text-[black] h-[40px] ps-[24px] bg-[#EEF2F6] rounded-[4px]' value={mission?.pages?.[tabIndex]?.url || 'xxx.yyy.com'} />
                        </div>
                    </div>
                    {/*end tabs*/}

                    {/*web content*/}
                    <div className='flex w-full flex-1 bg-[white]' style={{ overflowY: 'auto' }}>

                        <div className='w-full flex flex-col'>
                            {mission?.pages?.[tabIndex]?.contents?.map((item, index) =>
                                <div key={index} className='w-full flex flex-col rounded-[7px] gap-[8px]'>
                                    {item?.type?.includes('文章標題') && <div className='flex flex-col w-full gap-[8px]'>
                                        <div className={`px-[16px] font-[700]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: item.type === '文章標題(左對齊)' ? 'left' : item.type === '文章標題(居中對齊)' ? 'center' : 'right' }}>
                                            <MDEditor.Markdown wrapperElement={{ "data-color-mode": "light" }} source={item?.text || ''} style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent", fontSize: 32 }} />
                                        </div>
                                    </div>}
                                    {item?.type?.includes('閱讀文章內容') && <div className='flex flex-col w-full gap-[8px]'>
                                        <div className={`px-[16px]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: item.type === '閱讀文章內容(左對齊)' ? 'left' : item.type === '閱讀文章內容(居中對齊)' ? 'center' : 'right' }}>
                                            <MDEditor.Markdown wrapperElement={{ "data-color-mode": "light" }} source={item?.text || ''} style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent" }} />
                                        </div>
                                    </div>}
                                    {item?.type === '圖片' &&
                                        <div className='w-full flex flex-col'>
                                            {item?.photo && <div className='relative w-full flex flex-row justify-center p-[16px]' style={{ backgroundColor: item?.backgroundColor || 'white' }}>
                                                {
                                                    item?.photo
                                                        ? <img style={{ height: 400, width: 400, objectFit: 'contain', maxWidth: '100%' }} src={item?.photo} alt='image' />
                                                        : <div></div>
                                                }
                                            </div>}
                                        </div>
                                    }
                                    {item.type === '超連結' && <div className='flex flex-col w-full gap-[8px]'>
                                        <div className={`px-[16px]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: 'left' }}>
                                            <div cl style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent" }}>
                                                <div className='inline' dangerouslySetInnerHTML={{ __html: (item.redirects?.[0] ? item?.text?.slice(0, item.redirects?.[0]?.start) : item?.text) || '' }} />
                                                {item.redirects?.sort((a, b) => (a.start > b.start) ? 1 : (a.start < b.start) ? -1 : 0
                                                )?.map((r, ri) =>
                                                    <div className='inline' key={ri}>
                                                        <div className='inline text-[blue] cursor-pointer underline'
                                                            onClick={async () => {
                                                                let newTabIndex = mission?.pages.findIndex(p => p.id == r.pageId)
                                                                let mission_ = { ...mission }
                                                                mission_.pages[newTabIndex].initial = true
                                                                props.setmission(mission_)
                                                                settabIndex(mission?.pages.findIndex(p => p.id == r.pageId))
                                                            }}
                                                            dangerouslySetInnerHTML={{ __html: item?.text.slice(r.start, r.end) }}
                                                        />
                                                        <div className='inline' dangerouslySetInnerHTML={{
                                                            __html:
                                                                item.redirects?.[ri + 1] ?
                                                                    item?.text.slice(r.end, item.redirects?.[ri + 1].start)
                                                                    : item?.text.slice(r.end)
                                                        }} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>}
                                    {item.type === '彈出視窗' && <div className='flex flex-col w-full gap-[8px]'>
                                        <div className={`px-[16px]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: 'left' }}>
                                            <div cl style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent" }}>
                                                <div className='inline' dangerouslySetInnerHTML={{ __html: (item.popups?.[0] ? item?.text?.slice(0, item.popups?.[0]?.start) : item?.text) || '' }} />
                                                {item.popups?.sort((a, b) => (a.start > b.start) ? 1 : (a.start < b.start) ? -1 : 0
                                                )?.map((r, ri) =>
                                                    <div className='inline' key={ri}>
                                                        <div className='inline text-[blue] cursor-pointer underline' onClick={() => { setisShowPopup(r.text) }} dangerouslySetInnerHTML={{ __html: item?.text.slice(r.start, r.end) }} />
                                                        <div className='inline' dangerouslySetInnerHTML={{
                                                            __html:
                                                                item.popups?.[ri + 1] ?
                                                                    item?.text.slice(r.end, item.redipopupsrects?.[ri + 1].start)
                                                                    : item?.text.slice(r.end)
                                                        }} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>}
                                </div>
                            )}
                            <div className='w-full min-h-[64px]'></div>
                        </div>
                    </div>
                    {/*end of web content*/}
                </div>

                {/*end of webpages*/}
            </div>
            {/*end of content*/}

            {isShowPopup && <PopupWindow text={isShowPopup} onClose={() => { setisShowPopup(false) }} />}
            {isShowInstruction && <Instructions close={() => { setisShowInstruction(false) }} />}
            {isShowRemarksPopup!==null &&<div className='fixed top-0 left-0 w-full h-full bg-[#00000080] flex justify-center items-center'>
                <div className='bg-white w-[600px] h-[400px] rounded-[7px] p-[16px] flex flex-col gap-[16px]'>
                    <div className='text-[24px] font-[700]'>編輯老師評語</div>
                    <textarea className='w-full h-full border-[1px] border-black rounded-[7px] p-[4px]' value={isShowRemarksPopup||''} onChange={(e) => {setisShowRemarksPopup(e.target.value)}}/>
                    <div className='flex flex-row justify-end items-center gap-[8px]'>
                        <div onClick={() => { setisShowRemarksPopup(null) }} className='text-[#1F4CC8] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{ border: '1px solid #1F4CC8' }}>取消</div>
                        <div onClick={handleUpdateRemarks} className='bg-[#1F4CC8] text-white text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{ border: '1px solid #1F4CC8' }}>儲存</div>
                    </div>
                </div>
            </div>}
            {isloading && <LoadingPage />}
        </div>
    )

}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
